import { fetchWrapper } from "../utils/fetch-wrapper";
import { DPE } from "../interfaces/dpe"; 

const dpeService = {
    getAll,
    getById,
    post,
    update,
    delete: _delete,
    count
};

/**
 * Récupère la liste de tous les DPE
 */
function getAll() {
    return fetchWrapper.get("rapports/dpe");
}

/**
 * Récupère un DPE spécifique par son ID
 */
function getById(id: number) {
    return fetchWrapper.get(`rapports/dpe/${id}`);
}



/**
 * Crée un nouveau DPE
 */
function post(data: Partial<DPE>) {
    return fetchWrapper.post("rapports/dpe", data);
}

/**
 * Met à jour un DPE existant
 */
function update(id: number, params: Partial<DPE>) {
    return fetchWrapper.put(`rapports/dpe/${id}`, params);
}

/**
 * Supprime un DPE
 */
function _delete(id: number) {
    return fetchWrapper.delete(`rapports/dpe/${id}`);
}

/**
 * Récupère le nombre total de DPE
 */
function count(env_id: number) {
    return fetchWrapper.get(`rapports/dpe/count/${env_id}`);
}

export default dpeService;